module.exports = __webpack_public_path__ + "static/media/logo-epa-mini-M.4e1ff364.svg";